import React from "react";
import i18n from "micro-i18n";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/summary/ThankYou.scss';

const ThankYou = () => {
  return (
    <div className="csw-thank-you">
      <div className="h2 h-trim" role="heading" aria-level="1">
        {i18n.t("THANK_YOU_TITLE")}
      </div>
      <div className="csw-thank-you-detail">{i18n.t("THANK_YOU_BODY")}</div>
    </div>
  );
};

export default ThankYou;
